<template>
  <div class="d-flex align-center">
    <v-icon
      class="mr-1"
      :color="iconColor"
      :class="iconClass"
      :small="small"
    >
      {{ icon }}
    </v-icon>
    <span class="font-weight-medium mr-1 pt-2px" :class="{ small }">
      {{ text }}
    </span>
    <slot></slot>
  </div>
</template>

<script>
import { ScreeningAdviceState } from '@/enums';

const STATE_TO_STYLE = {
  [ScreeningAdviceState.CONTINUE]: {
    icon: 'thumb_up',
    iconColor: 'success',
    iconClass: 'material-icons-outlined',
    text: 'Continue Screening',
  },
  [ScreeningAdviceState.STOP]: {
    icon: 'error',
    iconColor: 'error',
    text: 'Stop Screening',
  },
  [ScreeningAdviceState.COMPLETE]: {
    icon: 'check_circle',
    iconColor: 'success',
    text: 'Screening Complete',
  },
};

export default {
  name: 'ScreeningAdviceStatusItem',
  props: {
    state: {
      type: String,
      required: true,
      validator: (val) =>
        Object.values(ScreeningAdviceState).includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return STATE_TO_STYLE[this.state];
    },
    icon() {
      return this.style.icon;
    },
    iconColor() {
      return this.style.iconColor;
    },
    iconClass() {
      return this.style.iconClass;
    },
    text() {
      return this.style.text;
    },
  },
};
</script>

<style scoped>
.small {
  font-size: 14px;
}

.pt-2px {
  padding-top: 2px;
}
</style>
